import React, {FormEvent, useState} from 'react';
import {IonBackButton, IonContent, IonPage} from '@ionic/react';
import {chevronBackOutline} from 'ionicons/icons';
import {Keyboard, KeyboardResize} from '@capacitor/keyboard';
import {Capacitor} from '@capacitor/core';
import {isValidEmail} from '../utilis/isValidEmail';
import actions from '../api/register';
import UIImage from '../components/UICommon/UIImage';
import UILogo from '../components/UICommon/UILogo';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import RegisterPageForm from '../components/RegisterPage/RegisterPageForm';

import img from '../assets/images/login.png';

const RegisterPage: React.FC = () => {
  const [formValues, setFormValues] =
      useState({firstName: '', lastName: '', email: '', password: '', repeatPassword: '', studio: ''});
  const [formErrorMessages, setFormErrorMessages] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isKeyboard, setKeyboard] = useState(0);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  if (Capacitor.isNativePlatform()) {
    Keyboard.setResizeMode({
      mode: KeyboardResize.None,
    });
    Keyboard.addListener('keyboardWillShow', (info) => {
      document?.activeElement?.scrollIntoView(true);
      setKeyboard(info.keyboardHeight);
      setIsKeyboardOpen(true);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setKeyboard(0);
      setIsKeyboardOpen(false);
    });
  }

  const onChange = (event: any) => {
    const {name, value} = event.target;
    setFormValues({...formValues, [name]: value});
  };

  const validate = () => {
    const errors = {firstName: '', lastName: '', email: '', password: '', repeatPassword: '', studio: ''};
    let isValid = true;

    if (!isValidEmail(formValues.email)) {
      errors.email = 'E-postadressen är ogiltig';
    }

    if (formValues.password.length < 6) {
      errors.password = 'Ditt lösenord måste innehålla minst 6 tecken';
    }

    if (formValues.repeatPassword !== formValues.password) {
      errors.repeatPassword = 'Lösenorden matchar inte';
    }

    Object.entries(formValues).forEach((key, index) => {
      if (!key[1]) {
        (errors as any)[key[0]] = 'Detta fältet är obligatoriskt';
      }
      if ((errors as any)[key[0]].length > 0) {
        isValid = false;
      }
    });

    setFormErrorMessages(errors);
    return isValid;
  };

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (validate()) {
      setLoading(true);
      setError('');
      actions.registerUser(
          formValues.firstName,
          formValues.lastName,
          formValues.email,
          formValues.password,
          formValues.studio,
      ).then(() => {
        setSuccess(true);
      }).catch((error) => {
        setError(error.message);
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  return (
    <IonPage className='flex flex-col max-h-screen justify-center items-center'>
      <IonContent className='login-background-mobile' fullscreen>
        <div className='absolute md:left-3 top-6'>
          <IonBackButton
            className='text-white md:text-navy-black'
            icon={chevronBackOutline}
            defaultHref="/"
            text=''/>
        </div>
        <div className='flex flex-row max-h-screen h-screen md:bg-gray-login'>
          <div className='w-full md:w-1/2 px-10 md:pl-16 md:pr-10 py-10 md:py-5 flex flex-col md:justify-between'>
            <div className='md:hidden pb-20'>
              <UILogo style='text-white text-2xl text-left leading-6'/>
            </div>
            <div className='font-Outfit text-white md:text-navy-secondary h-1/4 flex flex-col justify-between'>
              <h1 className='text-40 md:text-50 font-semibold'>Registrering</h1>
              <h2 className='text-lg font-semibold'>
                Är du redan medlem i SRT?<br/>Kontakta oss så får du ett gratis konto
              </h2>
              <p className='text-lg'>Annars fyll i stegen nedan:</p>
            </div>
            {loading && <UILoadingIndicator style='text-white md:text-navy-black'/>}
            {error && <UIErrorIndicator message={error}/>}
            <div className='h-1/2 mt-5 md:mt-0 md:h-auto'>
              { success ? (
                  <div className='text-green-500 rounded-xl h-full
                   items-center flex text-center font-semibold md:mb-60'>
                    Kolla din e -post och klicka på aktiveringslänken för att slutföra registreringen.</div>
                ) : (
              <RegisterPageForm
                formValues={formValues}
                onChange={onChange}
                errorMessages={formErrorMessages}
                submit={submit}
              />
              )}
              <div
                className='text-gray-primary font-Manrope text-sm font-semibold text-center w-full'>
                    @2022 SVERGIES REGISTRERADE TATUERARE
              </div>
            </div>
          </div>
          <div className='-z-10 md:z-0 md:w-1/2 md:p-5 h-1/2 absolute md:right-0 md:h-screen'>
            <UIImage url={img} style='md:rounded-3xl'/>
          </div>
        </div>
        {isKeyboardOpen && <div style={{height: isKeyboard - 80}}></div>}
      </IonContent>
    </IonPage>
  );
};

export default RegisterPage;
